import type { ReportData } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/student/overview/report-loader'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import ContentTile from 'teacher-ui-client/components/tiles/content'

interface ReportSignature {
  Args: {
    isReloading?: boolean
    reportData: ReportData
    studentName?: string
  }
}

export const Report: TOC<ReportSignature> = <template>
  <ContentTile class="p-6">
    <div class="mb-3 font-bold">
      {{@studentName}}
    </div>
    <div class="flex flex-wrap gap-4 print:block print:max-h-[unset] print:overflow-visible">
      <figure-box
        data-test-figure-box="0"
        class="bg-rexy-purple-300 print:border-dusty-black-200 flex shrink grow basis-0 items-center justify-between px-3 py-6 text-white print:border print:bg-transparent print:text-black"
      >
        <span>
          {{t "reporting.totalAssignmentsCompleted"}}
        </span>
        <span class="text-3xl font-bold">
          {{@reportData.overview.total_assignments_completed}}
        </span>
      </figure-box>
      <figure-box
        data-test-figure-box="1"
        class="bg-oceany-blue-300 print:border-dusty-black-200 flex shrink grow basis-0 items-center justify-between px-3 py-6 text-white print:border print:bg-transparent print:text-black"
      >
        <span>
          {{t "reporting.averageLexileLevel"}}
        </span>
        <span class="text-3xl font-bold">
          {{formatValue @reportData.overview.average_lexile_formatted}}
        </span>
      </figure-box>
      <figure-box
        data-test-figure-box="2"
        class="bg-oceany-blue-300 print:border-dusty-black-200 flex shrink grow basis-0 items-center justify-between px-3 py-6 text-white print:border print:bg-transparent print:text-black"
      >
        <span>
          {{t "reporting.lexileRange"}}
        </span>
        <span class="text-3xl font-bold whitespace-nowrap">
          {{formatValue @reportData.overview.lexile_range_formatted}}
        </span>
      </figure-box>
    </div>
  </ContentTile>
</template>
